import { Injectable } from "@angular/core";

declare let {
  Environment
}: any;


@Injectable()
export class EnvService {
    private readonly initConfiguration: InitConfiguration;
    constructor() {
        this.initConfiguration = new InitConfiguration(
            Environment.production,
            Environment.classificationServiceUrl,
            Environment.localizationServiceUrl,
            Environment.orderManagementServiceUrl,
            Environment.referenceDataServiceUrl,
            Environment.securityServiceUrl,
            Environment.tenantServiceUrl,
            Environment.systemServiceUrl,
            Environment.communicationServiceUrl,
            Environment.aadTenantId,
            Environment.appInsightsInstrumentationKey,
            Environment.aadClientId
        );
    }
    get(): InitConfiguration {
        return this.initConfiguration;
      }
    
      get host(): string {
        return window.location.hostname ;
      }
    
      reloadApp(): void {
        window.location.reload();
      }
    
      get languageCode(): string {
        return 'en';
      }
}

export class InitConfiguration {
    readonly production: boolean;
    readonly classificationServiceUrl: string;
    readonly localizationServiceUrl: string;
    readonly orderManagementServiceUrl: string;
    readonly referenceDataServiceUrl: string;
    readonly securityServiceUrl: string;
    readonly tenantServiceUrl: string;
    readonly systemServiceUrl: string;
    readonly communicationServiceUrl: string;
    readonly aadTenantId: string;
    readonly appInsightsInstrumentationKey: string;
    readonly aadClientId: string;
    constructor(
      production: boolean,
      classificationServiceUrl: string,
      localizationServiceUrl: string,
      orderManagementServiceUrl: string,
      referenceDataServiceUrl: string,
      securityServiceUrl: string,
      tenantServiceUrl: string,
      systemServiceUrl: string,
      communicationServiceUrl: string,
      aadTenantId: string,
      appInsightsInstrumentationKey: string,
      aadClientId: string
    ) {
      this.production = production;
      this.classificationServiceUrl = classificationServiceUrl;
      this.localizationServiceUrl = localizationServiceUrl;
      this.orderManagementServiceUrl = orderManagementServiceUrl;
      this.referenceDataServiceUrl = referenceDataServiceUrl;
      this.securityServiceUrl = securityServiceUrl;
      this.appInsightsInstrumentationKey = appInsightsInstrumentationKey;
      this.tenantServiceUrl = tenantServiceUrl;
      this.systemServiceUrl = systemServiceUrl;
      this.communicationServiceUrl = communicationServiceUrl;
      this.aadClientId = aadClientId;
      this.aadTenantId = aadTenantId;
    }
  };